import { PaginationState } from "@tanstack/react-table";

export type PaymentStatusFilter =
  | ""
  | "pending"
  | "confirmed"
  | "rejected"
  | "error";

export interface PaymentRow {
  id: string;
  userId?: string;
  clientId?: string;
  fecha: string;
  monto: number;
  amountUsd: number;
  rate: number;
  amountVef: number;
  cliente: string;
  reference: string;
  esDeTercero: boolean;
  status: string;
  statusName: string;
  errorMessage?: string;
}

export interface PaymentListParams {
  page?: number;
  limit?: number;
  globalFilter?: string;
  startDate?: string;
  endDate?: string;
  status?: PaymentStatusFilter;
  sortBy?: "fecha" | "monto";
  sortOrder?: "asc" | "desc";
}

export interface PaymentListResult {
  data: PaymentRow[];
  totalCount: number;
}

export interface PaymentIndicators {
  total: number;
  pending: number;
  confirmed: number;
  rejected: number;
  error: number;
  confirmedAmountUsd: number;
  confirmedAmountVef: number;
}

export type PaymentListPagination = PaginationState;

export const getEmptyPaymentIndicators = (): PaymentIndicators => ({
  total: 0,
  pending: 0,
  confirmed: 0,
  rejected: 0,
  error: 0,
  confirmedAmountUsd: 0,
  confirmedAmountVef: 0,
});
